export enum ApplicationPropertyTypeEnum {
  String = "String",
  Int = "Int",
  Json = "Json",
  Bool = "Bool",
  DeviceFamily = "DeviceFamily",
  SlaveId = "SlaveId",
}

export interface ApplicationPropertyGet {
  name: string
  type: ApplicationPropertyTypeEnum
  isRequestable: boolean
  possibleValues: ApplicationPropertyPossibleValue[]
}

export interface ApplicationPropertyPost {
  name: string
  type: "" | ApplicationPropertyTypeEnum
  isRequestable: boolean
}

export interface ApplicationPropertyPut {
  type: ApplicationPropertyTypeEnum
  isRequestable: boolean
}

export interface ApplicationPropertyDetail {
  id?: string
  name: string
  value: string
  label?: string
}

export interface ApplicationPropertyPossibleValue {
  value: string
  label: string
}

export interface ApplicationPropertyValPostRole {
  propertyValue: string
  roleId: string
  permissionId: string
}

export interface ApplicationPropertyValPostUser {
  propertyValue: string
  permissionId: string
  userId: string
}

export interface ApplicationPropertyValPostUserRole {
  propertyValue: string
  roleId: string
  userId: string
}
